import React from 'react'
import { Row, Column, View, Box, SectionIntro } from 'components/Layout'
import { ToDoListContainer, AppStatsContainer } from '../../containers'
import { DeleteAppButton } from '../../containers/Buttons'

const AppOverview = ({ props, match }) => {
	return (
		<View>
			<Row topMargin>
				<Column width={6}>
					<SectionIntro header={'App Overview'} />
				</Column>
			</Row>
			<Row>
				<Column width={6}>
					<Box
						header={'Building an app – checklist'}
						bodyPadding
						body={<ToDoListContainer appId={match.params.appId} />}
					/>
				</Column>
			</Row>
			<Row>
				<Column width={6}>
					<AppStatsContainer appId={match.params.appId} />
				</Column>
			</Row>
			<Row>
				<Column width={6}>
					<Box
						header={'Delete this app'}
						body={
							'You can remove this app from your account. Once you delete the app, there is no going back. Please be certain.'
						}
						bodyPadding
						footer={
							<span>
								<DeleteAppButton
									label={'Delete this app'}
									appId={match.params.appId}
								/>
							</span>
						}
					/>
				</Column>
			</Row>
		</View>
	)
}
export default AppOverview



// WEBPACK FOOTER //
// ./src/views/Apps/AppOverview.js